/* global require */
import { Component, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../media-query';
const uuidv4 = require('uuid/v4');

class PromoMessage extends Component {
    constructor(props) {
        super(props);

        this.uuid = uuidv4();
        this.state = {
            width: window.innerWidth,
            rendered: false,
            last_top: 0,
        };

        const tags = props.tags ? props.tags.split(',').map(tag => tag.trim()) : null;

        props.requirePromoMessage(this.uuid, props.placement, tags);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.updateDimensions);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextProps.messages != this.props.messages
            &&
            nextProps.messages[this.uuid]
            &&
            nextProps.messages[this.uuid] != this.props.messages[this.uuid]
        ) {
            return true;
        }

        if (nextState.last_top != this.state.last_top) {
            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            this.setState({ rendered: false });
            return true;
        }

        if (nextProps.promoPageViews != this.props.promoPageViews) {
            return true;
        }

        if (nextProps.report_id != this.props.report_id) {
            return true;
        }

        if (nextState != this.state) {
            return true;
        }

        return false;
    }

    render({ messages, placement, tags, mode }) {
        let doRender = true;

        if (placement == 'sidebar' && (MQ.isMobile() || MQ.isTabletPortrait())) {
            doRender = false;
        }

        if (messages && messages[this.uuid] && messages[this.uuid].message && doRender) {
            if (!this.state.rendered) {
                this.trackImpression();
                this.setState({ rendered: true });
            }

            let message = this.props.messages[this.uuid].message.replace(/\r\n|\n|\r|\t/gm, '');

            if (placement == 'in-product' && message.match(/\{report_ID\}/) && this.props.report_id) {
                message = message.replace(/\{report_ID\}/g, this.props.report_id);
            } else if (placement == 'text-vip-message') {
                message = `<p>${message}</p>`;
            }

            return (
                <promo-message
                    uuid={this.uuid}
                    dangerouslySetInnerHTML={{__html: message}}
                    onClick={this.trackClick}
                    placement={placement}
                    tags={tags}
                    ref={(elem) => { this.promoMessage = elem; }}
                    mode={mode}
                />
            );
        }

        return (<promo-message placement={placement} tags={tags} uuid={this.uuid} mode={mode} />);
    }

    trackClick = () => {
        const category = this.props.placement + ' promo message';
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';
        const label = this.props.messages[this.uuid].code;

        this.props.trackEvent([category, action, label]);
        this.props.trackPromo([category, label]);
    }

    trackImpression = () => {
        const action = this.props.logged_in ? 'LI Impression' : 'LO Impression';
        const label = this.props.messages[this.uuid].code;

        this.props.trackEvent([`${this.props.placement} promo message`, action, label]);
    }

    handleScroll = () => {
        if (
            (MQ.isMobile() || MQ.isTabletPortrait())
            &&
            this.props.placement == 'topbar'
            &&
            typeof this.promoMessage != 'undefined'
        ) {
            const top = window.pageYOffset;

            if (top >= 315 && top > this.state.last_top) {
                this.promoMessage.classList.add('shown');
            } else if (top < this.state.last_top) {
                this.promoMessage.classList.remove('shown');
            }

            this.setState({last_top: top});
        }
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    messages: state['promo-message'],
    promoPageViews: state.cookie && state.cookie.promo_page_views,
    report_id: state.report && state.report.constants && state.report.constants.product_slug,
});

const mapDispatchToProps = (dispatch) => ({
    requirePromoMessage: (uuid, placement, tags) => dispatch({ type: 'promo-message:require', payload: {
        uuid: uuid,
        placement: placement,
        tags: tags,
    }}),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoMessage);
